import { PortalConfigState } from "./types";

export const INITIAL_STATE: PortalConfigState = {
  config: null,
};
